import { datadogRum, RumInitConfiguration } from '@datadog/browser-rum';
import { datadogLogs, LogsInitConfiguration } from '@datadog/browser-logs';
import version from 'src/config/version.json';

const IS_DEVELOPMENT = process.env.NODE_ENV !== 'production';

const initConfig = {
  site: 'datadoghq.eu' as const,
  service: 'app.eu-label.info',
  applicationId: 'c592e095-045e-45e2-a052-6f5671d26a87',
  clientToken: 'pubf363b85ca511be279bae7c264b852388',
  env: process.env.NODE_ENV ?? '',
  version: version.version,
};

const dataDogRUMConfig: RumInitConfiguration = {
  version: '',
  applicationId: '',
  clientToken: '',
  sessionSampleRate: 100,
  sessionReplaySampleRate: 70,
  trackUserInteractions: true,
  trackResources: true,
  trackLongTasks: true,
  defaultPrivacyLevel: 'allow',
};

const dataDogLogsConfig: LogsInitConfiguration = {
  clientToken: '',
  site: 'datadoghq.eu',
  service: 'app.eu-label.info',
  forwardErrorsToLogs: true,
  version: '',
  env: '',
};

export const initDataDog = () => {
  if (IS_DEVELOPMENT) {
    return;
  }
  datadogLogs.init({ ...dataDogLogsConfig, ...initConfig });
  datadogRum.init({ ...dataDogRUMConfig, ...initConfig });
};

export const addError = (error: unknown, context?: object | undefined) => {
  if (IS_DEVELOPMENT) {
    return;
  }
  datadogRum.addError(error, context);
};

export const logError = (
  message: string,
  messageContext?: object | undefined,
) => {
  if (IS_DEVELOPMENT) {
    return;
  }
  datadogLogs.logger.log(message, messageContext);
};
